import React from 'react';
import { Box, Typography } from '@mui/material';

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'text.primary',
        py: 2,
        px: 3,
        /* 999.15542: pinned to the bottom of the viewport. The footer is the
           last flex child of the height:100dvh shell (App.js) and sits outside
           the scrolled area (the middle Box), so it never moves.
           margin-top:auto is gone — it was what let a short page park the
           footer somewhere other than the bottom edge. */
        flex: '0 0 auto',
        textAlign: 'center',
      }}
    >
      <Box sx={{ display: 'inline-flex', alignItems: 'baseline', gap: 0, mb: 0.5 }}>
        <Typography
          sx={{
            fontFamily: "'Playfair Display', serif",
            fontWeight: 700,
            fontSize: '1.1rem',
            color: 'secondary.main',
          }}
        >
          Raike
        </Typography>
        <Typography
          sx={{
            fontFamily: "'EB Garamond', serif",
            fontStyle: 'italic',
            fontWeight: 300,
            fontSize: '1.35rem',
            color: 'secondary.main',
            mx: '3px',
            lineHeight: 1,
          }}
        >
          &amp;
        </Typography>
        <Typography
          sx={{
            fontFamily: "'Playfair Display', serif",
            fontWeight: 400,
            fontSize: '1.1rem',
            color: 'secondary.main',
          }}
        >
          Sons
        </Typography>
      </Box>
      <Typography
        sx={{
          fontFamily: "'EB Garamond', serif",
          fontStyle: 'italic',
          color: 'background.default',
          opacity: 0.5,
          fontSize: '0.9rem',
          mb: 0.75,
        }}
      >
        Old school hustle. New school AI.
      </Typography>
      <Typography
        sx={{
          fontSize: '0.65rem',
          fontWeight: 600,
          letterSpacing: '0.3em',
          textTransform: 'uppercase',
          color: 'secondary.main',
          opacity: 0.5,
        }}
      >
        Est. 2025
      </Typography>
    </Box>
  );
}
